import {
  SendOtp,
  SendUserOtp,
  VerifyOtp,
  VerifyUserOtp
} from 'helpers/models';

export const mapSendUserOtp = (result) => {
  return new SendUserOtp(result).mapToStandard();
};

export const mapSendOtp = (result) => {
  return new SendOtp(result).mapToStandard();
};

export const mapVerifyUserOtp = (result) => {
  return new VerifyUserOtp(result).mapToStandard();
};

export const mapVerifyOtp = (result) => {
  return new VerifyOtp(result).mapToStandard();
};